import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { Control, Controller } from 'react-hook-form';

type Props = {
  control: Control<any>;
  onPregnantChange?: (checked: boolean, previousValue: boolean) => void;
};

export const TopFieldsSection = ({ control, onPregnantChange }: Props) => {
  return (
    <div className="aspiration-search-form-top content-panel">
      <div className="aspiration-search-form__section">
        <div className="aspiration-search-form__field">
          <label htmlFor="opuTime">OPU Time:</label>
          <Controller
            name="opuTime"
            control={control}
            render={({ field }) => (
              <div className="p-inputgroup">
                <InputText {...field} type="number" placeholder="hhmm" />
              </div>
            )}
          />
        </div>
        <div className="aspiration-search-form__field">
          <label htmlFor="didNotAspirate">Did Not Aspirate:</label>
          <Controller
            name="didNotAspirate"
            control={control}
            render={({ field }) => (
              <Checkbox
                checked={field.value}
                onChange={(e) => field.onChange(e.checked)}
              />
            )}
          />
        </div>
        <div className="aspiration-search-form__field">
          <label htmlFor="pregnant">Pregnant:</label>
          <Controller
            name="pregnant"
            control={control}
            render={({ field }) => (
              <Checkbox
                checked={field.value}
                onChange={(e) => {
                  const previousValue = field.value;
                  field.onChange(e.checked);
                  if (onPregnantChange) {
                    onPregnantChange(
                      e.checked ?? false,
                      previousValue ?? false,
                    );
                  }
                }}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};
